module.exports = __webpack_public_path__ + "static/img/enterprisec.4bad175.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/enterprisec.jpg
// module id = klr2
// module chunks = 1